import Vue from "vue";
import IconDelete from "../components/icons/IconDelete";
import IconExport from "../components/icons/IconExport";
import IconSearch from "../components/icons/IconSearch";
import IconAdd from "../components/icons/IconAdd";
import IconUpload from "../components/icons/IconUpload";
import IconClose from "../components/icons/IconClose";
import IconChevronRight from "../components/icons/IconChevronRight";
import IconChevronLeft from "../components/icons/IconChevronLeft";
import IconChevronDown from "../components/icons/IconChevronDown";
import IconPencil from "../components/icons/IconPencil";
import IconMinus from "../components/icons/IconMinus";
import IconAddZone from "../components/icons/IconAddZone";
import IconDraw from "../components/icons/IconDraw";
import IconUndo from "../components/icons/IconUndo";
import IconWrench from "../components/icons/IconWrench";
import IconEyeShow from "../components/icons/IconEyeShow";
import IconEyeHide from "../components/icons/IconEyeHide";
import IconWarning from "../components/icons/IconWarning";
import IconQuestionMark from "../components/icons/IconQuestionMark";
import IconBack from "../components/icons/IconBack";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      iconDelete: {
        component: IconDelete,
      },
      iconMinus: {
        component: IconMinus,
      },
      iconExport: {
        component: IconExport,
      },
      iconSearch: {
        component: IconSearch,
      },
      iconAdd: {
        component: IconAdd,
      },
      iconUpload: {
        component: IconUpload,
      },
      iconClose: {
        component: IconClose,
      },
      iconChevronRight: {
        component: IconChevronRight,
      },
      iconChevronLeft: {
        component: IconChevronLeft,
      },
      iconChevronDown: {
        component: IconChevronDown,
      },
      iconPencil: {
        component: IconPencil,
      },
      iconAddZone: {
        component: IconAddZone,
      },
      iconDraw: {
        component: IconDraw,
      },
      iconUndo: {
        component: IconUndo,
      },
      iconWrench: {
        component: IconWrench,
      },
      iconEyeShow: {
        component: IconEyeShow,
      },
      iconEyeHide: {
        component: IconEyeHide,
      },
      iconWarning: {
        component: IconWarning,
      },
      iconQuestionMark: {
        component: IconQuestionMark,
      },
      iconBack: {
        component: IconBack,
      },
    },
  },
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#FFC73C",
        secondary: "#f5f040",
        accent: "#37474f",
        error: "#b71c1c",
        gray: "#999999",
      },
      dark: {
        primary: "#FFC73C",
        secondary: "#00AEEF",
        accent: "#37474f",
        focus: "#73C8D2",
        error: "#ff0000",
        gray: "#999999",
      },
    },
  },
});
